<template>
    <expand-transition group>
        <fieldset v-if="customer.employment_status" class="flex w-full flex-wrap">
            <ValidationObserver slim :customer="customer" :rules="rules" ref="validationObserver" class="w-full">
                <expand-transition group>
                    <div v-if="showSalary">
                        <!-- <fancy-select
                            :options="defaultOptions"
                            label="What’s your monthly salary?"
                            :name="name + '.salary'"
                            :rules="{ required: true }"
                            :custom-messages="this.$getValidationMessages(name + '.salary')"
                            v-model="salaryIncomeSelect"
                            class="mb-8"
                            vid="salaryIncomeSelect"
                        ></fancy-select> -->

                        <expand-transition group>
                            <digi-currency
                                class="mb-8"
                                v-model.number="salary"
                                type="tel"
                                v-if="true"
                                name="salary"
                                :customer="customer"
                                :test="this.test"
                                :custom-messages="this.$getValidationMessages(name + '.salary')"
                                :rules="this.$getValidationRules(name + '.salary')"
                                label="What’s your monthly salary?"
                                :attributes="{ maxlength: 4 }"
                            ></digi-currency>
                        </expand-transition>
                    </div>
                </expand-transition>

                <fancy-select
                    :options="defaultOptions"
                    label="Monthly pension income"
                    :name="name + '.pension'"
                    :rules="{ required: true }"
                    :custom-messages="this.$getValidationMessages(name + '.pension')"
                    v-model="pensionIncomeSelect"
                    class="mb-8"
                ></fancy-select>

                <expand-transition group>
                    <digi-currency
                        class="mb-8"
                        v-model.number="pensionIncomeManual"
                        type="tel"
                        name="pensionIncomeManual"
                        v-if="pensionIncomeSelect == 'manual'"
                        :attributes="{ maxlength: 4 }"
                        :rules="{ required_if: { target: this.name + '.pension', values: 'manual' }, integer: true, min_value: 801 }"
                        label="If your income is over £801 please enter amount here"
                    ></digi-currency>
                </expand-transition>

                <fancy-select
                    :options="defaultOptions"
                    label="Monthly benefits income"
                    microtext="Please include any income from Universal Credit, Housing Benefit and any other benefits you receive."
                    :name="name + '.benefits'"
                    :rules="{ required: true }"
                    :custom-messages="this.$getValidationMessages(name + '.benefits')"
                    v-model="benefitsIncomeSelect"
                    class="mb-8"
                ></fancy-select>

                <expand-transition group>
                    <digi-currency
                        class="mb-8"
                        v-model.number="benefitsIncomeManual"
                        type="tel"
                        name="benefitsIncomeManual"
                        v-if="benefitsIncomeSelect == 'manual'"
                        :attributes="{ maxlength: 4}"
                        :rules="{ required_if: { target: this.name + '.benefits', values: 'manual' }, integer: true, min_value: 801 }"
                        label="If your income is over £801 please enter amount here"
                    ></digi-currency>
                </expand-transition>

                <fancy-select
                    :options="defaultOptions"
                    label="Other monthly income"
                    microtext="Please include any other income you receive."
                    :name="name + '.other'"
                    :rules="{ required: true }"
                    :custom-messages="this.$getValidationMessages(name + '.other')"
                    v-model="otherIncomeSelect"
                    class="mb-8"
                ></fancy-select>

                <expand-transition group>
                    <digi-currency
                        class="mb-8"
                        v-model.number="otherIncomeManual"
                        type="tel"
                        name="otherManual"
                        v-if="otherIncomeSelect == 'manual'"
                        :attributes="{ maxlength: 4}"
                        :rules="{ required_if: { target: this.name + '.other', values: 'manual' }, integer: true, min_value: 801 }"
                        label="If your income is over £801 please enter amount here"
                    ></digi-currency>
                </expand-transition>
            </ValidationObserver>

            <expand-transition group>
                <div class="w-full flex bg-white rounded shadow-lg p-4 flex-wrap mb-8 text-center" v-if="total > 0">
                    <div class="w-full text-sm">
                        Your total income is approximately
                    </div>
                    <div class="w-full text-2xl font-bold text-green mt-3 leading-6">
                        {{ total | currency }}
                    </div>
                </div>
            </expand-transition>
        </fieldset>
    </expand-transition>
</template>

<script>
import FancySelect from "./../../components/form/fancyselect";
import DigiInput from "./../../components/form/digi-input";
import DigiCurrency from "./../../components/form/digi-currency";
import {
    isNumber,
    isNull,
    isString,
    object,
    isObject,
} from "underscore";
export default {
    inject: ["$getValidationRules", "$getValidationMessages"],
    props: {
        customer: Object,
        rules: {
            type: Object,
            default: function () {
                return {};
            },
        },
        name: String,
        form: Object,
        defaultOptions: Object,
        value: Object,
        test: {
            default: false,
        }
    },
    methods: {
        castIncome(val) {
            if (isNumber(val) || (isString(val) && /^[0-9]+$/.test(val))) {
                return parseInt(val, 10);
            } else {
                return null;
            }
        },
    },
    data() {
        return {
            upperLimit: 1600,
            salary: this.customer.salary ?? null,
            salaryIncomeSelect: null,
            benefitsIncomeSelect: null,
            pensionIncomeSelect: null,
            otherIncomeSelect: null,
            salaryIncomeManual: null,
            benefitsIncomeManual: null,
            pensionIncomeManual: null,
            otherIncomeManual: null,
        };
    },
    computed: {
        showSalary() {
            return [
                "emp_fulltime",
                "emp_parttime",
                "emp_self",
                "benefits_and_fulltime",
                "benefits_and_parttime",
                "armed_forces",
                "emp_temporary",
            ].includes(this.customer.employment_status);
        },
        total() {
            return Object.values(this.income).reduce((total, thisNum) => {
                if (isNumber(thisNum)) {
                    total = isNumber(total) ? total : 0;
                    total += thisNum;
                }
                return total;
            }, null);
        },
        income() {
            return {
                // salary: !this.showSalary
                //     ? 0
                //     : this.castIncome(
                //           this.salaryIncomeSelect == "manual"
                //               ? this.salaryIncomeManual
                //               : this.salaryIncomeSelect
                //       ),
                salary: !this.showSalary
                    ? 0
                    : this.castIncome(this.salary),
                benefits: this.castIncome(
                    this.benefitsIncomeSelect == "manual"
                        ? this.benefitsIncomeManual
                        : this.benefitsIncomeSelect
                ),
                pension: this.castIncome(
                    this.pensionIncomeSelect == "manual"
                        ? this.pensionIncomeManual
                        : this.pensionIncomeSelect
                ),
                other: this.castIncome(
                    this.otherIncomeSelect == "manual"
                        ? this.otherIncomeManual
                        : this.otherIncomeSelect
                ),
            };
        },
    },
    watch: {
        watch: {
            showSalary() {
                this.$emit("input", this.income);
            },
        },
        income: {
            deep: true,
            immediate: true,
            handler() {
                // Set the netpay as the total of these
                this.$set(this.customer, "netpay", this.total);
                this.$emit("input", this.income);
            },
        },
    },
    created() {
        if (isObject(this.value)) {
            if (isNumber(this.value.salary)) {
                if (
                    Object.keys(this.defaultOptions).includes(
                        this.value.salary.toString()
                    )
                ) {
                    this.salaryIncomeSelect = this.value.salary.toString();
                } else if (this.value.salary > this.upperLimit) {
                    this.salaryIncomeSelect = "manual";
                    this.salaryIncomeManual = this.value.salary;
                }
            }
            if (isNumber(this.value.pension)) {
                if (
                    Object.keys(this.defaultOptions).includes(
                        this.value.pension.toString()
                    )
                ) {
                    this.pensionIncomeSelect = this.value.pension.toString();
                } else if (this.value.pension > this.upperLimit) {
                    this.pensionIncomeSelect = "manual";
                    this.pensionIncomeManual = this.value.pension;
                }
            }
            if (isNumber(this.value.benefits)) {
                if (
                    Object.keys(this.defaultOptions).includes(
                        this.value.benefits.toString()
                    )
                ) {
                    this.benefitsIncomeSelect = this.value.benefits.toString();
                } else if (this.value.benefits > this.upperLimit) {
                    this.benefitsIncomeSelect = "manual";
                    this.benefitsIncomeManual = this.value.benefits;
                }
            }
            if (isNumber(this.value.other)) {
                if (
                    Object.keys(this.defaultOptions).includes(
                        this.value.other.toString()
                    )
                ) {
                    this.otherIncomeSelect = this.value.other.toString();
                } else if (this.value.other > this.upperLimit) {
                    this.otherIncomeSelect = "manual";
                    this.otherIncomeManual = this.value.other;
                }
            }
        }
    },
    components: {
        "fancy-select": FancySelect,
        "digi-currency": DigiCurrency,
        "expand-transition": () =>
            import("./../../components/expand-transition"),
    },
};
</script>

<style lang="scss">
</style>